import { defineMessages } from 'react-intl';

export default defineMessages({
  balanceInAave: 'Your balance in SSAP',
  loanToValue: 'Loan to value',
});
